import React from "react";
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {

  render() {
    const factoryItemList = this.props.factoryItemList;
    const searchData = this.props.searchData;
    const itemRequestDetail = this.props.itemRequestDetail;
    const cellStyle = {
      border: '1px solid black',
      padding: '2px 6px',
      fontSize: '0.9rem',
    };

    return (
      <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', padding: '20px' }}>
        <h3><center><u>Factory Item Details Report</u></center></h3>
        <div>&nbsp;</div>
        <h4><center>{searchData.groupName} - {searchData.factoryName}</center></h4>
        <h4><center>Route : {itemRequestDetail.routeID == 0 ? 'All Route' : searchData.routeName} </center></h4>
        <h4><center> Factory Item : {itemRequestDetail.factoryItemID == 0 ? 'All' : searchData.itemName} - Category : {itemRequestDetail.itemCategoryID == 0 ? 'All' : searchData.categoryName}</center></h4>
        <h4><center>  Reg No : {itemRequestDetail.registrationNumber === "" ? 'All Reg No' : itemRequestDetail.registrationNumber}</center></h4>
        <h4><center>From Date - {searchData.startDate} - To Date - {searchData.endDate}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table" style={{ borderCollapse: 'collapse', width: '99%' }}>
                <TableHead>
                  <TableRow style={{ border: '1px solid black' }}>
                    <TableCell align="left" style={cellStyle}>Route Name</TableCell>
                    <TableCell align="left" style={cellStyle}>Date</TableCell>
                    <TableCell align="left" style={cellStyle}>Reg No</TableCell>
                    <TableCell align="left" style={cellStyle}>Supplier Name</TableCell>
                    <TableCell align="left" style={cellStyle}>Category</TableCell>
                    <TableCell align="left" style={cellStyle}>Item</TableCell>
                    <TableCell align="left" style={cellStyle}>Quantity</TableCell>
                    <TableCell align="left" style={cellStyle}>Total Price (Rs)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {factoryItemList.map((data, index) => (
                    <TableRow key={index}>
                      <TableCell align="left" style={cellStyle}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.date.split('T')[0]}
                      </TableCell>
                      <TableCell align="center" style={cellStyle}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.name}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.categoryName}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.itemName}
                      </TableCell>
                      <TableCell align="center" style={cellStyle}>
                        {data.approvedQuantity}
                      </TableCell>
                      <TableCell align="right" style={cellStyle}>
                        {data.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
